export const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_UPLOAD_MODEL_SIZE = 150 * 1024 * 1024; // 150MB
export const MAX_UPLOAD_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB

export const MAX_UPLOAD_FILE_COUNT = 50;

export const importModelHelpLink = 'https://dtstack.yuque.com/easyv/rx8vgf/dghm41lpksp7t95x';
